import { Modal } from '@tag/tag-components-react-v4';
import * as React from 'react';

export interface IModalWindowProps {
  isOpen: boolean;
  children: React.JSX.Element;
  onClose: () => void;
  heading: string;
}

const buttonHiddenStyle = {
  color: 'transparent',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'none',
};

export default function ModalWindowWithNoButtons({
  isOpen,
  children,
  onClose,
  heading,
}: IModalWindowProps) {
  return (
    <Modal
      visible={isOpen}
      onClose={onClose}
      heading={heading}
      primaryButtonProps={{
        buttonStyle: buttonHiddenStyle,
      }}
      cancelButtonProps={{
        buttonStyle: buttonHiddenStyle,
      }}
    >
      {children}
    </Modal>
  );
}
